export default __webpack_public_path__ + "static/young-fcfe22f7640380d8ab0ce2f2d4a71684.jpg";